<template>
  <div v-if="visible" class="booking-auto-actions">
    <app-actions-menu ref="menu" :actions="actions" @select="open" />
    <booking-auto-action-modal :name="modalName" :booking="booking" :action="selected" @updated="$emit('updated', $event)" @status-change="$emit('status-change', $event)" @closed="closed" />
  </div>
</template>

<script>
import AppActionsMenu from '@/components/AppActionsMenu.vue'
import BookingAutoActionModal from './BookingAutoActionModal.vue'
import { code, hasBookingSalesRole } from './booking-detail'
import { bookingAutoActions } from './booking-auto-actions'

export default {
  name: 'BookingAutoActions',
  components: { AppActionsMenu, BookingAutoActionModal },
  props: { booking: { type: Object, required: true } },
  data() { return { selected: null, requestId: 0 } },
  computed: {
    visible() { return code(this.booking.booking_mode) === 'aerocrs' && hasBookingSalesRole(this.$store.state.userGroups) },
    actions() { return bookingAutoActions(this.booking, this.$store.state.userGroups) },
    modalName() { return `booking-auto-action-${this.booking.id}` }
  },
  beforeDestroy() { this.requestId++ },
  methods: {
    async open(action) {
      const allowed = this.actions.find(item => item.code === action.code)
      if (this.selected || !this.visible || !allowed || allowed.disabled) return
      const requestId = ++this.requestId
      const bookingId = this.booking.id
      this.selected = allowed
      await this.$nextTick()
      if (this.isCurrentRequest(requestId, bookingId) && this.visible && this.actions.some(item => item.code === action.code && !item.disabled)) this.$modal.show(this.modalName)
      else this.selected = null
    },
    isCurrentRequest(requestId, bookingId) { return requestId === this.requestId && bookingId === this.booking.id },
    closed() {
      this.selected = null
      if (this.$refs.menu) this.$refs.menu.focusToggle()
    }
  }
}
</script>
